import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { DetailsPanel } from "@/components/common";
import {
  DeltaPanelNav,
  ArtifactDeltas,
  TraceDeltas,
} from "@/components/delta/display";

/**
 * Displays project version delta information.
 */
const __default__ = {
  name: "DeltaPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), { panel: "delta" }, {
    default: _withCtx(() => [
      _createVNode(_unref(DeltaPanelNav)),
      _createVNode(_unref(ArtifactDeltas)),
      _createVNode(_unref(TraceDeltas))
    ]),
    _: 1
  }))
}
}

})